export default __webpack_public_path__ + "static/Dubai-f36c274299dc6336eb1c81bceadf20d3.svg";